import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "../../style/import-Chillax.css";
import "../../style/CreateAlbum.css";
import AlbumDetail from "../album/AlbumDetail";
import { useAlbumStore } from "../../stores/useStore";

const CreateAlbum = () => {
  const albumStore = useAlbumStore();

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [showDate, setShowDate] = useState(false);

  // au démarrage
  useEffect(() => {
    albumStore.addPreviewAlbum({
      albumTitle: "",
      groupId: 0,
      dateAlbum: "",
      imageUrl: null,
    });
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    if (selectedFile) {
      const objectUrl = URL.createObjectURL(selectedFile);
      albumStore.previewAlbum.imageUrl = objectUrl;
    } else {
      albumStore.previewAlbum.imageUrl = null;
    }
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    if (albumStore.previewAlbum) {
      albumStore.previewAlbum.dateAlbum = value;
    }
    setShowDate(true);
  };

  const handleAlbumTitleChange = (e) => {
    const value = e.target.value;
    if (albumStore.previewAlbum) {
      albumStore.previewAlbum.albumTitle = value;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setMessage("Veuillez sélectionner un fichier.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch("/api/upload", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setMessage(`Image uploadée avec succès : ${data.filename}`);
      } else {
        setMessage("Erreur lors de l'upload");
      }
    } catch (err) {
      console.error("Erreur :", err);
      setMessage("Erreur réseau");
    }
  };



  console.log(albumStore.previewAlbum)
  return (
    <form className="createAlbum_content" onSubmit={handleSubmit}>
      <p className="createAlbum_instruction">
        Les champs contenant * sont obligatoires
      </p>
      <div className={`createAlbum_imageLabelDiv ${file ? `file` : ``}`}>
        <input
          className="createAlbum_inputFile hidden"
          type="file"
          id="createAlbum_imageInput"
          accept="image/*"
          onChange={handleFileChange}
        />
        <label
          htmlFor="createAlbum_imageInput"
          className="createAlbum_imageButton"
        >
          {file ? "Modifier l'image" : "Choisir une image*"}
        </label>
        {file ? (
          <p className="createAlbum_imageName">Image Choisi : {file.name}</p>
        ) : null}
      </div>
      <div className="createAlbum_titleDiv">
        <label htmlFor="createAlbum_titleInput">Titre de l'album*</label>
        <input
          type="text"
          id="createAlbum_titleInput"
          value={albumStore.previewAlbum?.albumTitle}
          onChange={handleAlbumTitleChange}
          required
        />
      </div>
      <div className="createAlbum_dateDiv">
        <label htmlFor="createAlbum_dateInput">Date de l'album*</label>
        <input
          type="date"
          id="createAlbum_dateInput"
          value={albumStore.previewAlbum?.dateAlbum}
          onChange={handleDateChange}
          required
        />
      </div>
      {albumStore?.previewAlbum?.imageUrl && (
        <AlbumDetail
          album={albumStore.previewAlbum}
          group={albumStore.getGroupById(albumStore.previewAlbum.groupId)}
          showCorrectionOnFlip={showDate}
        />
      )}
      <button type="submit">Créer l'album</button>
      {message && <p>{message}</p>}
    </form>
  );
};

CreateAlbum.propTypes = {
  connected: PropTypes.bool,
};

export default CreateAlbum;
